<template>
  <popup-layout :title="`${uploadTypeName} 업로드`" :is-show="isShow" width="500">
    <template v-slot:content>
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <v-col cols="8" class="d-flex justify-space-between align-center">
            <v-col cols="4">기준년월</v-col>
            <v-text-field
                v-model="baseYm"
                outlined hide-details dense
                background-color="white"
                maxLength="6"
            />
          </v-col>
          <v-col cols="4" class="d-flex justify-end">
            <v-btn class="button excel" outlined @click="clickUpload(uploadType)">
              엑셀업로드
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
      <input
          @input="loadData"
          class="d-none"
          :accept="SheetJSFT"
          id="excel"
          type="file"
          ref="file"
      />
    </template>
    <template v-slot:button>
      <div class="d-flex justify-center align-center">
        <v-btn class="button delete" outlined @click="closePopup">
          닫기
        </v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import XLSX from "xlsx";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "PaymentExcelUploadPopup",
  components: {PopupLayout},
  props: ["isShow", "uploadType"],
  data() {
    return {
      baseYm: "",
      SheetJSFT: ["xlsx", "xlsb", "xlsm", "xls", "xml", "csv"].map(x => "." + x).join(","),
    };
  },
  computed: {
    uploadTypeName() {
      return this.uploadType === "info" ? "지급명세" : "거래내역";
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.baseYm = "";
      }
    }
  },
  methods: {
    clickUpload(type) {
      if (!this.baseYm || this.baseYm.length !== 6) {
        this.showAlert({message: "기준년월을 입력해주세요."});
        return false;
      }
      this.uploadType = type;
      this.$refs.file.click();
    },
    loadData({ target: { files }}) {
      if (!files || files.length < 1) {
        this.showAlert({ message: "올바른 파일이 아닙니다" });
        return false;
      } else {
        this._setReader(this.uploadType).readAsBinaryString(files[0]);
      }
    },
    _setReader(type) {
      const reader = new FileReader();
      const headers =
          type === "info"
              ?
              [
                "orgNm",
                "positionType",
                "loanBrokerNo",
                "memberNm",
                "ssno",
                "headMgrCommission",
                "managementMgrCommission",
                "salesMgrCommission",
                "teamMemberCommission",
                "operatingCost",
                "recruitingCost",
                "settlementSupportAmount",
                "annualAwardAmount",
                "giftCardAwardAmount",
                "otherAmount",
                "totalCommission",
                "incomeTaxAmount",
                "localTaxAmount",
                "employmentInsuranceAmount",
                "industrialAccidentInsuranceAmount",
                "loanDeductionAmount",
                "otherDeductionAmount",
                "dualSupportAmount",
                "adjustmentDifferenceAmount",
                "totalDeductionAmount",
                "netPaymentAmount"
              ]
              :
              [
                "baseYm",
                "paymentYm",
                "loanBrokerNo",
                "orgNm",
                "agentName",
                "headMgrId",
                "headMgrNm",
                "managementMgrId",
                "managementMgrNm",
                "salesMgrId",
                "salesMgrNm",
                "branchNm",
                "collateralType",
                "loanAmount",
                "feeTotal",
                "commissionNet"
              ]
      reader.onload = async ({ target: { result }}) => {
        const { Sheets, SheetNames }= XLSX.read(result, { type: "binary" });
        const dataList = XLSX.utils.sheet_to_json(Sheets[SheetNames], {
          range: type === "info" ? 6 : 4,
          header: headers,
          defval: ""
        });

        const refinedData = dataList.map(item => {
          return {
            ...item,
            ssno: item.ssno ? String(item.ssno).replace(/-/g, "") : "",
            loanBrokerNo: item.loanBrokerNo ? String(item.loanBrokerNo).replace(/-/g, "") : "",
            ...(type === "detail" && {
              paymentYm: String(item.paymentYm)
            })
          }
        })
        await this.fileUpload(type, refinedData);
      }
      return reader;
    },
    async fileUpload(type, list) {
      let apiUrl = type === "info" ? "/admin/statement/info" : "/admin/statement/detail";
      try {
        await axiosInstance.put(apiUrl, list,{
          params: {
            baseYm: this.baseYm
          }
        }).then(() => {
          const typeMessage = type === "info" ? "지급명세" : "거래내역";
          this.showAlert({
            message: `${typeMessage} 파일이 업로드 완료되었습니다.`,
            successCallback: () => {
              this.closePopup();
            }
          });
        })

      } catch (error) {
        await this.showAlert({ message: `${error.response.data.message}` });
      }
    },
    closePopup() {
      this.$emit("close");
    }
  }
}
</script>